define('OutSystems/ClientRuntime/modules/Database/TableInfoUtils',["require", "exports", "../../DataTypes"], function (require, exports, DataTypes_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.hasNullIdentifier = exports.getIdentifierValue = exports.getIdentifierAttribute = exports.getIdentifierColumnNames = exports.getIdentifierColumns = exports.getIdentifierColumn = exports.getMatchingColumn = exports.formatObjectName = exports.METADATA_TABLE_NAME = exports.BACKUP_TABLE_PREFIX = void 0;
    exports.BACKUP_TABLE_PREFIX = "BACKUP_";
    exports.METADATA_TABLE_NAME = "OSSYS_ENTITY";
    function formatObjectName(objectName) {
        return objectName ? objectName.toUpperCase() : objectName;
    }
    exports.formatObjectName = formatObjectName;
    function getMatchingColumn(table, attribute) {
        return table.attributes.filter(function (col) { return col.name === attribute.name; })[0] || null;
    }
    exports.getMatchingColumn = getMatchingColumn;
    function getIdentifierColumn(table) {
        return getIdentifierColumns(table)[0] || null;
    }
    exports.getIdentifierColumn = getIdentifierColumn;
    function getIdentifierColumns(table) {
        return table.attributes.filter(function (column) { return column.isPrimaryKey; });
    }
    exports.getIdentifierColumns = getIdentifierColumns;
    function getIdentifierColumnNames(table) {
        var tableComposedKey = getIdentifierColumns(table);
        return tableComposedKey.length > 0 ? tableComposedKey.map(function (attr) { return attr.columnName; }) : null;
    }
    exports.getIdentifierColumnNames = getIdentifierColumnNames;
    function getIdentifierAttribute(info, recordOrType) {
        var idColumn = getIdentifierColumn(info);
        if (!idColumn) {
            return null;
        }
        return recordOrType.getAttributes().filter(function (attr) { return attr.name === idColumn.name; })[0] || null;
    }
    exports.getIdentifierAttribute = getIdentifierAttribute;
    function getIdentifierValue(info, record) {
        var idColumn = getIdentifierColumn(info);
        if (!idColumn) {
            return null;
        }
        var idAttr = record.getAttributes().filter(function (attr) { return attr.name === idColumn.name; })[0];
        return idAttr ? record[idAttr.attrName] : null;
    }
    exports.getIdentifierValue = getIdentifierValue;
    function hasNullIdentifier(info, record) {
        var idColumn = getIdentifierColumn(info);
        if (!idColumn) {
            return true;
        }
        var idAttr = record.getAttributes().filter(function (attr) { return attr.name === idColumn.name; })[0];
        return idAttr ? DataTypes_1.equals(record[idAttr.attrName], DataTypes_1.defaultForType(idAttr.dataType)) : true;
    }
    exports.hasNullIdentifier = hasNullIdentifier;
});
//# sourceMappingURL=TableInfoUtils.js.map;
